var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7552_37439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8206 8.64354C14.0079 8.64354 14.1736 8.63759 14.3394 8.64428C14.972 8.67178 15.4938 9.1869 15.5317 9.81873C15.5384 9.92948 15.5428 10.041 15.5428 10.1525C15.5436 12.6203 15.5399 15.0881 15.5458 17.5567C15.5473 18.0294 15.4202 18.4308 15.0374 18.7304C14.798 18.9177 14.5252 18.9965 14.2264 18.998C13.8124 19.0002 13.3976 18.9987 12.9836 18.9987C9.11832 18.9987 5.25306 18.9972 1.38779 19.0002C0.822125 19.001 0.385796 18.7794 0.140501 18.2666C0.0483291 18.074 0.0104198 17.8391 0.00967648 17.6228C0.000756645 15.0874 0.00967648 12.5519 1.33253e-05 10.0157C-0.00295995 9.24711 0.492091 8.76916 1.031 8.66584C1.24656 8.62496 1.47327 8.63834 1.726 8.6257C1.726 8.55657 1.72526 8.48595 1.726 8.41534C1.73492 7.46909 1.72006 6.5221 1.75945 5.57734C1.81371 4.29289 2.30431 3.16676 3.13385 2.19226C3.88981 1.304 4.8026 0.634266 5.92576 0.279702C6.79916 0.00467366 7.69114 -0.0629685 8.59948 0.0567061C10.3901 0.291595 11.7445 1.23264 12.7777 2.66799C13.5173 3.69451 13.8191 4.86599 13.8206 6.12145C13.8213 6.95026 13.8206 7.77906 13.8206 8.64354ZM4.32019 8.62496C6.63489 8.62496 8.92431 8.62496 11.2167 8.62496C11.2167 7.64823 11.2412 6.6834 11.2041 5.72155C11.19 5.36178 11.0822 4.98566 10.9342 4.65414C10.2816 3.19129 8.87154 2.42418 7.27563 2.62711C5.92873 2.79881 4.75131 3.85804 4.425 5.17372C4.30681 5.64945 4.32168 6.12889 4.32093 6.61056C4.31945 7.27732 4.32019 7.94407 4.32019 8.62496Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7552_37439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5458,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.898ab85721b0cc20d771ef1952eacc1a.svg";
export { ForwardRef as ReactComponent };